import {
  AgxRow,
  AgxTextArea,
  AgxTextInput,
  Breakpoints,
  ITableUpdatingModal,
  Popup,
  useWindowSize,
  AgxDivider,
} from '@urbanx/agx-ui-components'
import './supplierUpdateModal.scss'
import { useState } from 'react'
import './supplierUpdateModal.scss'
import { AgencySupplier } from '@urbanx/agx.agencies.client'
import { ActionButton } from 'components/Popup/Popup'

const SupplierUpdateModal = ({
  isEditMode,
  updateableData: { ...supplier },
  onSave,
  onDelete,
  onClose,
}: ITableUpdatingModal<AgencySupplier>) => {
  const [currentSupplier, setSupplier] = useState<AgencySupplier>(supplier)
  const [confirmDelete, setConfirmDelete] = useState(false)
  const [shouldValidate, setShouldValidate] = useState({
    companyName: false,
    email: false,
    phone: false,
  })
  const isMobile = useWindowSize() === Breakpoints.Mobile

  const cellIds = {
    companyName: 'companyName',
    email: 'email',
    phone: 'phone',
    notes: 'notes',
  }

  const width = { widthInPX: isMobile ? 370 : 500 }

  const onSupplierUpdate = ({ id, value }: { id: string; value: string }) => {
    let updatedSupplier = { ...(currentSupplier ?? {}) }

    switch (id) {
      case cellIds.companyName:
        updatedSupplier = {
          ...updatedSupplier,
          companyName: value,
        }
        break
      case cellIds.email:
        updatedSupplier = {
          ...updatedSupplier,
          email: { address: value },
        }
        break
      case cellIds.phone:
        updatedSupplier = {
          ...updatedSupplier,
          phone: { number: value },
        }
        break
      case cellIds.notes:
        updatedSupplier = {
          ...updatedSupplier,
          notes: value,
        }
        break
      default:
        console.log(`Supplier field ${value} could not be found`)
    }

    setSupplier(updatedSupplier)
  }

  const modalActionButtons: ActionButton[] = [
    {
      id: 'supplier-save-changes',
      title: 'Save Changes',
      isPrimary: true,
      clickHandler: () => {
        setShouldValidate({
          companyName: currentSupplier?.companyName ? false : true,
          email: currentSupplier?.email?.address ? false : true,
          phone: currentSupplier?.phone?.number ? false : true,
        })

        if (
          !currentSupplier?.companyName ||
          !currentSupplier?.email?.address ||
          !currentSupplier?.phone?.number
        )
          return

        onSave(currentSupplier)
      },
    },
    {
      id: isEditMode ? 'supplier-delete' : 'supplier-cancel',
      title: isEditMode ? 'Delete' : 'Cancel',
      closePopupOnClick: false,
      clickHandler: () => {
        isEditMode ? setConfirmDelete(true) : onClose()
      },
    },
  ]
  const deleteActionButtons: ActionButton[] = [
    {
      id: 'confirm-supplier-delete',
      title: 'Delete',
      isPrimary: true,
      clickHandler: () => onDelete(currentSupplier?.supplierId ?? null),
    },
    {
      id: 'cancel-supplier-delete',
      title: 'Cancel',
      closePopupOnClick: true,
      clickHandler: () => setConfirmDelete(false),
    },
  ]

  return (
    <>
      <Popup
        title={isEditMode ? 'Edit Supplier' : 'Add Supplier'}
        isOpen={!confirmDelete}
        centered
        actionButtonsCentered
        actionButtons={modalActionButtons}
        onClose={onClose}
        size={width}
      >
        <div className="agx-modal-body">
          <AgxRow>
            <AgxTextInput
              id={cellIds.companyName}
              required
              validate={shouldValidate.companyName}
              stretch
              label="Company Name"
              defaultValue={supplier?.companyName}
              onInputValueChange={(data) => onSupplierUpdate(data)}
            />
          </AgxRow>
          <AgxRow>
            <AgxTextInput
              id={cellIds.email}
              required
              validate={shouldValidate.email}
              stretch
              label="Email"
              defaultValue={supplier?.email?.address}
              onInputValueChange={(data) => onSupplierUpdate(data)}
            />
          </AgxRow>
          <AgxRow>
            <AgxTextInput
              id={cellIds.phone}
              required
              validate={shouldValidate.phone}
              stretch
              label="Phone"
              defaultValue={supplier?.phone?.number}
              onInputValueChange={(data) => onSupplierUpdate(data)}
            />
          </AgxRow>
          <AgxRow>
            <AgxTextArea
              id={cellIds.notes}
              stretch
              noResize
              maxLength={100}
              rows={3}
              label="Notes"
              noOptionalLabel
              showCharCount
              placeholder="Enter notes here"
              defaultValue={supplier?.notes}
              onInputValueChange={(data) => onSupplierUpdate(data)}
            />
          </AgxRow>
        </div>
      </Popup>
      <Popup
        title={`Are you sure you want to delete ${currentSupplier.companyName}?`}
        isOpen={confirmDelete}
        centered
        size={width}
        actionButtonsCentered
        actionButtons={deleteActionButtons}
        onClose={onClose}
      >
        <AgxDivider />
      </Popup>
    </>
  )
}

export default SupplierUpdateModal
